

export const VIEW_ONCHANGE = 'VIEW_ONCHANGE';
export const updateView = (value) => ({
    type: VIEW_ONCHANGE,
    payload: {
        value
    },
}
);



